const PermanentFeatureFlagKeys = {
    ShowArchivesLink: "ShowArchivesLink",
    UseLogRocket: "UseLogRocket",
    UseHoneycomb: "UseHoneycomb",
    MixpanelSessionRecordingEnabled: "MixpanelSessionRecordingEnabled",
    AiFeaturesEnabled: "AiFeaturesEnabled",
    MaintenancePageEnabled: "MaintenancePageEnabled",
    UpdatedMigrateAssessmentThresholdsEnabled: "UpdatedMigrateAssessmentThresholdsEnabled",
    TenantRoleConflictGuardKillSwitch: "TenantRoleConflictGuardKillSwitch"
} as const;

const TemporaryFeatureFlagKeys = {
    ReportGenerationAiErrorMessageReleased: "ReportGenerationAiErrorMessageReleased",
    RecommendationsTabReleased: "RecommendationsTabReleased",
    IsMigrateApiReleased: "IsMigrateApiReleased",
    UserCentricPmrReleased: "UserCentricPmrReleased",
    GroupCentricPmrReleased: "GroupCentricPmrReleased",
    DelegatedReviewsFilesReleased: "DelegatedReviewsFilesReleased",
    DelegatedReviewsEnrichedSummaryReleased: "DelegatedReviewsEnrichedSummaryReleased",
    MigrationPlanReleased: "MigrationPlanReleased",
    MigrationActivityReleased: "MigrationActivityReleased",
    StaticRecommendationDisplayReleased: "StaticRecommendationDisplayReleased",
    InlineDataRegionSelectionReleased: "InlineDataRegionSelectionReleased",
    UserDetailsCardReleased: "UserDetailsCardReleased",
    WorkspaceDetailsCardReleased: "WorkspaceDetailsCardReleased",
    RemoveSharingLinkRecipientBulkAction: "RemoveSharingLinkRecipientBulkAction",
    ReportSharingReleased: "ReportSharingReleased",
    AccessReportSharingReleased: "AccessReportSharingReleased",
    NewPricingReleasedV1: "NewPricingReleasedV1",
    NewPricingV2Released: "NewPricingV2Released"
} as const;

// Not real LaunchDarkly flags — these keys only exist so getFeatureFlag/useFeatureFlag calls have
// something to key off of when gating dev-only behavior via the call's local default value. There's
// no corresponding LD flag to check state against. Odd pattern, ideally this group stays empty.
const LocalOnlyFeatureFlagKeys = {} as const;

export const FeatureFlagKeys = {
    ...PermanentFeatureFlagKeys,
    ...TemporaryFeatureFlagKeys,
    ...LocalOnlyFeatureFlagKeys
} as const;

export const AllFeatureFlagKeys = Object.values(FeatureFlagKeys);

export type FeatureFlagKeys = (typeof FeatureFlagKeys)[keyof typeof FeatureFlagKeys];

const flagsFalseByDefault: FeatureFlagKeys[] = [
    FeatureFlagKeys.UpdatedMigrateAssessmentThresholdsEnabled,
    FeatureFlagKeys.MaintenancePageEnabled,
    FeatureFlagKeys.IsMigrateApiReleased,
    FeatureFlagKeys.TenantRoleConflictGuardKillSwitch,
    FeatureFlagKeys.RecommendationsTabReleased,
    FeatureFlagKeys.MigrationPlanReleased,
    FeatureFlagKeys.MigrationActivityReleased,
    FeatureFlagKeys.StaticRecommendationDisplayReleased,
    FeatureFlagKeys.InlineDataRegionSelectionReleased,
    FeatureFlagKeys.UserDetailsCardReleased,
    FeatureFlagKeys.WorkspaceDetailsCardReleased,
    FeatureFlagKeys.RemoveSharingLinkRecipientBulkAction,
    FeatureFlagKeys.NewPricingReleasedV1,
    FeatureFlagKeys.NewPricingV2Released,
    FeatureFlagKeys.AccessReportSharingReleased,
    FeatureFlagKeys.DelegatedReviewsEnrichedSummaryReleased
];

export const DefaultTestFeatureFlags: Record<FeatureFlagKeys, boolean> = AllFeatureFlagKeys.reduce(
    (flags, flag) => {
        flags[flag] = !flagsFalseByDefault.includes(flag);
        return flags;
    },
    {} as Record<FeatureFlagKeys, boolean>
);
